<div class="report-wrapper">
	<header class="report-header">
		<div class="logo-block">
			<div class="logo-block">
				<img 
					src="/sctportal/images/sct-logo.webp" 
					alt="Smart Charge Technologies" 
					height="45"
					width="auto"
				>
			</div>
		</div>
		<div class="study-id-label">{{ studyInfo.id }} / {{device.config_info.truck_id}}</div>
	</header>

	<section class="report-title-section">
		<h1 class="report-title">{{'studies.power_study_report' | translate}}</h1>
		<div class="report-meta">
			<p class="meta-line"><span class="meta-label">Site:</span> {{siteInfo.name}} | {{siteInfo.address}}</p>
			<p class="meta-line"><span class="meta-label">Period:</span> {{selectedPeriodFormatted}}</p>
		</div>
	</section>

	<div class="divider-blue"></div>

	<section class="ratings-section">
		<h2 class="section-heading">{{ studyInfo.id }} / Battery / Truck Ratings</h2>

		<div class="ratings-grid">
			<div class="ratings-column">
				<div class="rating-row">
					<span class="rating-label">{{'truck_reports.truck_id' | translate}}</span>
					<span class="rating-value">{{studyInfo.truck_id}}</span>
				</div>
				<div class="rating-row">
					<span class="rating-label">{{'truck_reports.truck_type' | translate}}</span>
					<span class="rating-value">{{studyInfo.truck_type}}</span>
				</div>
				<div class="rating-row">
					<span class="rating-label">{{ 'truck_reports.truck_sn' | translate}}</span>
					<span class="rating-value">{{studyInfo.truck_sn}}</span>
				</div>
			</div>

			<div class="ratings-column">
				<div class="rating-row">
					<span class="rating-label">{{'g.iotah_ps_sn' | translate}}:</span>
					<span class="rating-value">{{device.config_info.serial_number}}</span>
				</div>
				<div class="rating-row">
					<span class="rating-label">{{'devices.battery_capacity' | translate}}:</span>
					<span class="rating-value">{{studyInfo.battery_capacity}}</span>
				</div>
				<div class="rating-row">
					<span class="rating-label">{{'rt.voltage' | translate}}:</span>
					<span class="rating-value">{{ studyInfo.nominal_battery_voltage }}</span>
				</div>
			</div>
		</div>
	</section>
</div>